import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import SetupHierarchy from "../../../containers/modules/master/setup-hierarchy";

export default function SetupHierarchyRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="setup-hierarchy"
      index
      element={
        <AccessControl
          name={"Customer Setup Hierarchy List"}
          auth={authUser}
          component={() => <SetupHierarchy authUser={authUser} />}
        />
      }
    />
  );
}
